import { formatDate } from '@angular/common';

export type DateOnly = string & { __type: 'DateOnly' };

export function toDateOnly(value: Date): DateOnly {
  return formatDate(value, 'yyyy-MM-dd', 'en-US') as DateOnly;
}
